import * as yup from "yup";
import direccionValidacionEsquema from "../../../catalogos/direccionValidacionEsquema";

const paradaValidacionEsquema = yup.object().shape({
    direccion: direccionValidacionEsquema(true)
});

export default paradaValidacionEsquema;